import React from "react";
import { HintView } from "lib/components/index";
import st from "lib/utils/index";

const Hint = () => {
  if (!st.authorize.company.supplier && !st.authorize.company.agent) {
    return null;
  } else
    return (
      <HintView.Hint>
        <h3>{I18n.t("papp.settings.PaymentsSettingsView.hint.p1")}</h3>
        <p>{I18n.t("papp.settings.PaymentsSettingsView.hint.p2")}</p>

        <h3>{I18n.t("papp.settings.PaymentsSettingsView.hint.p3")}</h3>
        <p>{I18n.t("papp.settings.PaymentsSettingsView.hint.p4")}</p>

        <h3>{I18n.t("papp.settings.PaymentsSettingsView.hint.p5")}</h3>
        <p>{I18n.t("papp.settings.PaymentsSettingsView.hint.p6")}</p>

        <h3>{I18n.t("papp.settings.PaymentsSettingsView.hint.p7")}</h3>
        <p>{I18n.t("papp.settings.PaymentsSettingsView.hint.p8")}</p>
      </HintView.Hint>
    );
};

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/settings/PaymentsSettingsView/PaymentsSettingsHint.jsx